import BillingIdentityForm from '@/components/e_invoicing/BillingIdentityForm'
import PlatformConnectionCard from '@/components/e_invoicing/PlatformConnectionCard'
import { EInvoicingConnection, SharedProps } from '@/types'
import { Head, usePage } from '@inertiajs/react'
import { Stack, Title } from '@mantine/core'

export default function EInvoicingSettingsShow({
  connection,
  oauth_available,
  missing_fields,
  next_invoice_number,
  invoicing_basis_locked,
}: {
  connection: EInvoicingConnection | null
  oauth_available: boolean
  missing_fields: string[]
  next_invoice_number: string
  invoicing_basis_locked: boolean
}) {
  const { current_organization } = usePage<SharedProps>().props

  return (
    <>
      <Head title={`Facture électronique - ${current_organization?.name}`} />

      <Stack maw={640} mx="auto" w="100%">
        <Title ta="center" order={2}>
          Facture électronique
        </Title>

        <PlatformConnectionCard connection={connection} oauthAvailable={oauth_available} />
        <BillingIdentityForm
          missingFields={missing_fields}
          nextInvoiceNumber={next_invoice_number}
          invoicingBasisLocked={invoicing_basis_locked}
        />
      </Stack>
    </>
  )
}
